import * as React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"
import { FluentProvider } from "@fluentui/react-components"
import { useTheme } from "./hooks/useTheme"
import "../i18n"
import "../styles.css"

/* global document, Office, module, require, HTMLElement */

// Theme wrapper component
const ThemedApp: React.FC = () => {
  const { theme } = useTheme('auto')
  
  return (
    <FluentProvider theme={theme}>
      <div className="w-full h-full bg-white dark:bg-[#181A34] text-black dark:text-white">
        <App />
      </div>
    </FluentProvider>
  )
}

const rootElement: HTMLElement | null = document.getElementById("container")
const root = rootElement ? createRoot(rootElement) : undefined

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(<ThemedApp />)
})

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default
    root?.render(NextApp)
  })
}
